import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
    class: "account-tag",
    "data-test": "account-tag"
};
const _hoisted_2 = ["href", "title"];
const _hoisted_3 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_i18n = _resolveDirective("i18n");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.nickname !== undefined)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[0] || (_cache[0] = _createTextVNode(" 👤 ", -1)),
                _createElementVNode("a", {
                    href: _ctx.myGamesHref,
                    title: _ctx.myGamesTitle
                }, _toDisplayString(_ctx.nickname), 9, _hoisted_2)
            ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _withDirectives((_openBlock(), _createElementBlock("span", null, [...(_cache[1] || (_cache[1] = [
                        _createTextVNode("Log in to save this game in \"My games\".", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                _withDirectives((_openBlock(), _createElementBlock("a", {
                    href: _ctx.loginHref,
                    "data-test": "account-tag-login"
                }, [...(_cache[2] || (_cache[2] = [
                        _createTextVNode("Log in", -1)
                    ]))], 8, _hoisted_3)), [
                    [_directive_i18n]
                ])
            ], 64))
    ]));
}
